import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/finance/subsidy',
  title: '车辆残值管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
